import { useState, useEffect } from 'react'
import { GoPersonFill } from "react-icons/go";
import { GoSmiley } from "react-icons/go";
import { FaMicrochip } from "react-icons/fa6";
import { FaFaceLaugh } from "react-icons/fa6";
import { BiSolidUserRectangle } from "react-icons/bi";
import Icons from '../Icons/Icons';

import Render from '../Render/Render';

export function ImageContent( props )
{
    const type = props.type 
    const layers = props.layers 
    const layerIdx = props.layerIdx
    const layersCfg = props.layersCfg

    const [ src, setSrc ] = useState(null)

    useEffect(() => {
        let s = `data:${layers[layerIdx].filetype}, ${layers[layerIdx].patch}`;
        setSrc(s)
    },[])

    return (
        <div className="d-flex justify-content-center align-items-center"
             style={{ height:'100%', width:'100%' }}
        >
            { src &&
            <img src={src} 
                 style={{ height:'100%', width:'100%' }} 
                 draggable="false" 
            />
            }
        </div>
    )
}

export function TextContent( props )
{
    const type = props.type 
    const layers = props.layers 
    const layerIdx = props.layerIdx
    const layersCfg = props.layersCfg

    const [ text, setText ] = useState(null)

    const [ fontColor, setFontColor ] = useState(null)
    const [ fontFace, setFontFace ] = useState(null)
    const [ fontHeight, setFontHeight ] = useState(null)
    const [ fontStyle, setFontStyle ] = useState(null)
    const [ textAlignment, setTextAlignment ] = useState(null)

    useEffect(() => {
        let props = layersCfg.current[layers[layerIdx].id].properties 

        if( props == null )
        {
            return
        }

        setText( props.preset )

        if( props.source == "preset" )
        {
            setText( props.preset )
        }

        if( props.font )
        {
            if( props.font.color )
            {
                setFontColor(`rgba(${props.font.color.r},${props.font.color.g},${props.font.color.b},${props.font.color.a})`)
            }
            setFontFace(props.font.font_face)
            setFontHeight(props.font.font_height)
            setFontStyle(props.font.font_style)
            setTextAlignment(props.font.text_alignment)
        }

    },[type,layers])

    return (
        <div className="d-flex align-items-center"
             style={{ height:'100%', width:'100%', userSelect: 'none',
                      fontFamily:fontFace, fontSize:fontHeight, fontWeight:fontStyle,
                      justifyContent:textAlignment, color:fontColor }}
        >
            { text } 
        </div>
    )
}

export function AvatarContent( props )
{
    const type = props.type 
    const layers = props.layers 
    const layerIdx = props.layerIdx
    const layersCfg = props.layersCfg

    useEffect(() => {
    },[type])

    return (
        <div className="d-flex justify-content-center align-items-center"
             style={{ height:'100%', width:'100%',position: 'relative'}}
        >
            <BiSolidUserRectangle style={{ height: '60%', width:'60%' }}/>
        </div>
    )
}

export function EmoticonContent( props )
{
    const type = props.type 
    const layers = props.layers 
    const layerIdx = props.layerIdx
    const layersCfg = props.layersCfg

    useEffect(() => {
    },[type])

    return (
        <div className="d-flex justify-content-center align-items-center"
             style={{ height:'100%', width:'100%', position: 'relative'}}
        >
            <FaFaceLaugh style={{ height: '60%', width:'60%' }}/>
        </div>
    )
}

export function DynoContent( props )
{
    const type = props.type 
    const tag = props.tag
    const layers = props.layers 
    const layerIdx = props.layerIdx
    const layersCfg = props.layersCfg

    useEffect(() => {
    },[type])

    return (
        <div className="d-flex justify-content-center align-items-center"
             style={{ height:'100%', width:'100%', position:'relative'}}
        >
            <Render dynoTag={tag} />
            {/*<Icons type={tag} style={{ height: '60%', width:'60%' }} />*/}
        </div>
    )
}

export default function LayerContent( props )
{
    const layers = props.layers 
    const layerIdx = props.layerIdx 
    const layersCfg = props.layersCfg

    const [ type, setType ] = useState(null)
    const [ tag, setTag ] = useState(null)

    const load = () => {
        setType( layers[layerIdx].type )
        setTag( layers[layerIdx].tag )
    }

    useEffect( () => {
        load()
    },[])

    useEffect( () => {
        load()
    },[layers])

    if( type == null )
    {
        return <></>
    }

    if( type == "image" )
    {
        return <ImageContent type={type} 
                             layers={layers}
                             layerIdx={layerIdx}
                             layersCfg={layersCfg}
            /> 
    }
    else if( type == "text" )
    {
        return <TextContent type={type} 
                             layers={layers}
                             layerIdx={layerIdx}
                             layersCfg={layersCfg}
            />
    }
    else if( type == "avatar" )
    {
        return <AvatarContent type={type} 
                              layers={layers}
                              layerIdx={layerIdx}
                              layersCfg={layersCfg}
            />
    }
    else if( type == "emoticon" )
    {
        return <EmoticonContent type={type} 
                              layers={layers}
                              layerIdx={layerIdx}
                              layersCfg={layersCfg}
            />
    }
    else if( type == "dyno" )
    {
        return <DynoContent type={type} 
                            tag={tag}
                            layers={layers}
                            layerIdx={layerIdx}
                            layersCfg={layersCfg}
            />
    }

    return (
        <div className="d-flex justify-content-center align-items-center"
             style={{ height:'100%', width:'100%'}}
        >
        </div>
    )
}
